module.exports = __webpack_public_path__ + "static/footer-texture-a9291a70197cb58a351b3f13c2f44956.png";